import type { PivotChartSpecPipeline, VChartSpecPipeline } from 'src/types'
import {
  animationMorph,
  datasetXY,
  backgroundColor,
  label,
  tooltipHeatmap,
  initPivot,
  datasetPivot,
  pivotIndicators,
  pivotAdapter,
  pivotIndicatorsAsRow,
  pivotGridStyle,
  pivotColumnDimensions,
  pivotRowDimensions,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
  discreteLegend,
  color,
  colorAdapter,
  linearColor,
  heatmapColorLegend,
  cellStyle,
  pivotDiscreteLegend,
  pivotTitle,
  pivotAxisStyle,
  heatmapBandAxis,
  pivotColorLegend,
  heatmapColorDomain,
  brush,
  fontFamilyTheme,
} from '../pipes'
import { initHeatmap } from '../pipes/init/heatmap'

const heatmap: VChartSpecPipeline = [
  fontFamilyTheme,
  initHeatmap,
  backgroundColor,
  datasetXY,
  animationMorph,
  colorAdapter(color, linearColor),
  label,
  heatmapBandAxis,
  brush,
  colorAdapter(discreteLegend, heatmapColorLegend),
  cellStyle,
  tooltipHeatmap,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationArea,
]

const pivotHeatmap: PivotChartSpecPipeline = [
  initPivot,
  pivotGridStyle,
  pivotIndicatorsAsRow,
  datasetPivot,
  pivotIndicators([
    fontFamilyTheme,
    initHeatmap,
    backgroundColor,
    datasetXY,
    animationMorph,
    colorAdapter(color, linearColor),
    label,
    pivotAxisStyle(heatmapBandAxis),
    brush,
    tooltipHeatmap,
    cellStyle,
    annotationPoint,
    annotationVerticalLine,
    annotationHorizontalLine,
    annotationArea,
  ]),
  heatmapColorDomain,
  pivotRowDimensions,
  pivotColumnDimensions,
  pivotTitle,
  colorAdapter(pivotDiscreteLegend, pivotColorLegend),
]

export const heatmapSpecPipeline = [pivotAdapter(heatmap, pivotHeatmap)]
